const DATE_FORMAT = 'DD MMM YYYY';
const PO_TYPES = [
  {
    label: 'FG Domestic',
    value: 'DOMESTIC_PO',
    href: 'domestic'
  },
  {
    label: 'FG International',
    value: 'INTERNATIONAL_PO',
    href: 'international'
  }
];
const PO_INTER_ENTITY_TYPES = [
  {
    label: 'FG Domestic',
    value: 'DOMESTIC_PO',
    href: 'domestic'
  }
];
const ASN_TYPES = [
  {
    label: 'FG Domestic',
    value: 'DOMESTIC_ASN',
    href: 'domestic'
  },
  {
    label: 'FG International',
    value: 'INTERNATIONAL_ASN',
    href: 'international'
  }
];
const GRN_TYPES = [
  {
    label: 'FG Domestic',
    value: 'DOMESTIC_GRN',
    href: 'domestic'
  },
  {
    label: 'FG International',
    value: 'INTERNATIONAL_GRN',
    href: 'international'
  }
];
const CUSTOMER_PO_TYPES = [
  { label: 'Domestic Online', value: 'DOMESTIC_ONLINE', href: 'online' },
  { label: 'Domestic Offline', value: 'DOMESTIC_OFFLINE', href: 'offline' },
  { label: 'Domestic Online Excess', value: 'DOMESTIC_ONLINE_EXCESS', href: 'online-excess' }
];
const DOMESTIC_SO_TYPES = [
  {
    label: 'Domestic Online',
    value: 'DOMESTIC_ONLINE',
    href: 'domestic-online'
  },
  {
    label: 'Domestic Offline',
    value: 'DOMESTIC_OFFLINE',
    href: 'domestic-offline'
  },
  {
    label: 'Internal Stock Transfer',
    value: 'INTERNAL_STOCK_TRANSFER',
    href: 'internal-stock-transfer'
  },
  {
    label: 'Refurbish Internal',
    value: 'REFURBISH_INTERNAL',
    href: 'refurbish-internal'
  },
  {
    label: 'Refurbish External',
    value: 'REFURBISH_EXTERNAL',
    href: 'refurbish-external'
  },
  {
    label: 'Liquidation',
    value: 'LIQUIDATION',
    href: 'liquidation'
  },
  { label: 'Domestic Online Excess', value: 'DOMESTIC_ONLINE_EXCESS', href: 'online-excess' }
];
const INTERNATIONAL_SO_TYPES = [
  {
    label: 'Export Online',
    value: 'EXPORT_ONLINE',
    href: 'export-online'
  },
  {
    label: 'International Stock Transfer',
    value: 'INTERNATIONAL_STOCK_TRANSFER',
    href: 'international-stock-transfer'
  },
  {
    label: 'Export Online Warehouse Shipping',
    value: 'EXPORT_ONLINE_WH_SHIPPING',
    href: 'warehouse-shipping'
  }
];
const SO_DOMESTIC_GRN_TYPES = [
  {
    label: 'Domestic Online',
    value: 'DOMESTIC_ONLINE',
    href: 'domestic-online'
  },
  {
    label: 'Domestic Online Excess',
    value: 'DOMESTIC_ONLINE_EXCESS',
    href: 'domestic-online-excess'
  },
  {
    label: 'Domestic Offline',
    value: 'DOMESTIC_OFFLINE',
    href: 'domestic-offline'
  },
  {
    label: 'Internal Stock Transfer',
    value: 'INTERNAL_STOCK_TRANSFER',
    href: 'internal-stock-transfer'
  },
  {
    label: 'Refurbish Internal',
    value: 'REFURBISH_INTERNAL',
    href: 'refurbish-internal'
  },
  {
    label: 'Refurbish External',
    value: 'REFURBISH_EXTERNAL',
    href: 'refurbish-external'
  }
];

const SO_INTERNATIONAL_GRN_TYPES = [
  {
    label: 'Export Online',
    value: 'EXPORT_ONLINE',
    href: 'export-online'
  },
  {
    label: 'International Stock Transfer',
    value: 'INTERNATIONAL_STOCK_TRANSFER',
    href: 'international-stock-transfer'
  },
  {
    label: 'Export Online Warehouse Shipping',
    value: 'EXPORT_ONLINE_WH_SHIPPING',
    href: 'warehouse-shipping'
  }
];

const FILE_TYPE_ATTRIBUTE = {
  csv: 'text/csv',
  pdf: 'application/pdf',
  image: 'image/*',
  jpg: 'image/jpeg,image/jpg,image/png',
  excel: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  imagePdfCsv: 'image/*,.pdf,.csv'
};

const FILE_TYPE_FOR_ERROR = {
  'text/csv': 'CSV',
  'application/pdf': 'PDF',
  'image/*': 'Image',
  'application/vnd.ms-excel': 'Excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel'
};

const FACILITY_TYPES = {
  PHYSICAL: 'Physical Facility',
  VIRTUAL: 'Virtual Facility'
};

const ATTACHMENT_TYPES = {
  PO: 'PO_SKU_MAPPING'
};

const MAX_FILE_SIZE = 5 * 1024 * 1024;

const STYLES = {
  ICON: { fontSize: 24 },
  TITLE: { color: '#454C53' },
  TEXT: { color: '#4F5459', maxWidth: 150 },
  LABEL: { width: 150, color: '#454C53' },
  CONTENT: { color: '#1A1D21' },
  CARD: { width: 180 }
};

const BULK_UPLOAD_INVOICE_TYPES = {
  DOMESTIC_ONLINE: 'DOMESTIC_ONLINE',
  EXPORT_ONLINE: 'EXPORT_ONLINE',
  DOMESTIC_OFFLINE: 'DOMESTIC_OFFLINE',
  INTERNAL_STOCK_TRANSFER: 'INTERNAL_STOCK_TRANSFER',
  VIRTUAL_STOCK_TRANSFER: 'VIRTUAL_STOCK_TRANSFER',
  EXPORT_OFFLINE: 'EXPORT_OFFLINE'
};

const USER_MANAGEMENT_PERMISSION_GROUP = 'SUPER_ADMIN';

const DOCUMENT_CANCEL_REASONS = [
  {
    label: 'Duplicate',
    value: 'DUPLICATE'
  },
  {
    label: 'Data Entry Mistake',
    value: 'DATA_ENTRY_MISTAKE'
  },
  {
    label: 'Order Cancelled',
    value: 'ORDER_CANCELLED'
  },
  {
    label: 'Others',
    value: 'OTHERS'
  }
];

const SHIPMENT_CANCEL_REASONS = [
  {
    label: 'Duplicate Entry',
    value: 'DUPLICATE'
  },
  {
    label: 'Data Entry Mistake',
    value: 'DATA_ENTRY_MISTAKE'
  },
  {
    label: 'Order Cancelled',
    value: 'ORDER_CANCELLED'
  },
  {
    label: 'Wrong Courier Selected',
    value: 'WRONG_COURIER'
  },
  {
    label: 'Address Change Required',
    value: 'ADDRESS_CHANGE'
  },
  {
    label: 'Excessive Delivery Delay',
    value: 'DELIVERY_DELAY'
  },
  {
    label: 'Others',
    value: 'OTHERS'
  }
];

const DISPATCH_STATUS_OPTIONS = [
  {
    label: 'FM Connection Pending',
    value: 'FM_CONNECTION_PENDING'
  },
  {
    label: 'In Transit',
    value: 'INTRANSIT'
  },
  {
    label: 'Arrived at LM',
    value: 'ARRIVED_AT_LM'
  },
  {
    label: 'OFD',
    value: 'OFD'
  },
  {
    label: 'Undelivered',
    value: 'UNDELIVERED'
  },
  {
    label: 'Misrouted',
    value: 'MISROUTED'
  }
];

const USER_ROLE_KEY = 'https://lumos.mensa.one/roles';

// UAR (User Access Review) Constants
const UAR_PERMISSION_GROUP = 'SUPER_ADMIN';
const UAR_TECH_GROUP = 'UAR_TECH';
const UAR_ROLE = 'UAR';
// Groups allowed to access the Access Control (UAR) menu
const UAR_ALLOWED_GROUPS = [UAR_PERMISSION_GROUP, UAR_ROLE];

// Vendor Bills Constants
const VENDOR_BILL_PERMISSION_GROUP = 'SUPER_ADMIN';

const UAR_REVIEW_TYPES = [
  { label: 'POSI', value: 'POSI' },
  { label: 'AWS', value: 'AWS' },
  { label: 'DATABASE', value: 'DATABASE' },
  { label: 'JENKINS', value: 'JENKINS' },
  { label: 'GITHUB', value: 'GITHUB' }
];

const UAR_STATUS = {
  PENDING_REVIEW: 'PENDING_REVIEW',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  COMPLETED: 'COMPLETED'
};

const UAR_USER_STATUS = {
  PENDING: 'PENDING',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  RESOLVED: 'RESOLVED'
};

const UAR_STATUS_OPTIONS = [
  { label: 'Pending Review', value: 'PENDING_REVIEW', color: 'orange' },
  { label: 'Action Required', value: 'ACTION_REQUIRED', color: 'red' },
  { label: 'Completed', value: 'COMPLETED', color: 'green' }
];

const SO_DN_TYPE_OPTIONS = [
  { label: 'Fail', value: 'FAIL' },
  { label: 'Short', value: 'SHORT_QUANTITY' },
  { label: 'Fail & Short', value: 'FAIL_AND_SHORT_QUANTITY' }
];

const SO_DN_TYPE_LABELS = {
  FAIL: 'Fail',
  SHORT_QUANTITY: 'Short',
  FAIL_AND_SHORT_QUANTITY: 'Fail & Short'
};

export {
  DATE_FORMAT,
  PO_TYPES,
  PO_INTER_ENTITY_TYPES,
  ASN_TYPES,
  GRN_TYPES,
  DOMESTIC_SO_TYPES,
  INTERNATIONAL_SO_TYPES,
  FILE_TYPE_ATTRIBUTE,
  CUSTOMER_PO_TYPES,
  SO_DOMESTIC_GRN_TYPES,
  SO_INTERNATIONAL_GRN_TYPES,
  FACILITY_TYPES,
  ATTACHMENT_TYPES,
  MAX_FILE_SIZE,
  STYLES,
  FILE_TYPE_FOR_ERROR,
  BULK_UPLOAD_INVOICE_TYPES,
  USER_MANAGEMENT_PERMISSION_GROUP,
  DOCUMENT_CANCEL_REASONS,
  SHIPMENT_CANCEL_REASONS,
  USER_ROLE_KEY,
  DISPATCH_STATUS_OPTIONS,
  UAR_PERMISSION_GROUP,
  UAR_TECH_GROUP,
  UAR_ROLE,
  UAR_ALLOWED_GROUPS,
  VENDOR_BILL_PERMISSION_GROUP,
  UAR_REVIEW_TYPES,
  UAR_STATUS,
  UAR_STATUS_OPTIONS,
  UAR_USER_STATUS,
  SO_DN_TYPE_OPTIONS,
  SO_DN_TYPE_LABELS
};
